import { ConversationBuilderState } from "@/modules/conversation-builder";
import { Select, Form } from "ant-design-vue";
import { WrappedFormUtils } from "ant-design-vue/types/form/form";
import { debounce } from "lodash";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { Conversation, ConversationNode, Dialog } from "../../conversation-builder.model";
@Component({
	components: {
		Form,
		FormItem: Form.Item,
		Select,
		SelectOption: Select.Option
	}
})
export default class ExternalConversationProperties extends Vue {
	@Prop() node!: ConversationNode<Conversation>;
	public form!: WrappedFormUtils;

	public conversationStore = getModule(ConversationBuilderState);
	public externalConversationList = [
		{ id: "0", name: "A Good Monkey" },
		{ id: "1", name: "Dance like an elephant" },
		{ id: "2", name: "Fly like a bird" }
	];

	created() {
		this.form = this.$form.createForm(this, {
			name: "external-conversation-properties",
			onValuesChange: debounce(this.onValuesChange, 1000)
		});
	}

	mounted() {
		this.setValues();
	}

	@Watch("conversationStore.selectedNode")
	onChange() {
		this.setValues();
	}

	private setValues() {
		this.form.setFieldsValue({
			id: this.node.id
		});
	}

	private onValuesChange(props: any, fields: Partial<ConversationNode>) {
		if (fields.id) {
			const name = this.externalConversationList.find((item) => item.id === fields.id)?.name;
			if (name) {
				this.conversationStore.updateNodeData<Conversation>({
					id: this.node.id,
					data: { name }
				});
			}
		}
	}
}
